// src/PaymentForm.tsx
import React from 'react';
import FormField from 'ui/form/FormField';
import PaymentArea from '../areas/PaymentArea';
import { MainModal } from 'components/modal/Modal';
import { Button, useTheme } from '@rneui/themed';
import { useTranslation } from 'react-i18next';

interface Props {
  value?: object;
  setFieldValue: any;
  setFieldTouched: any;
  style?: object;
}

const PaymentForm: React.FC<Props> = ({
  value,
  setFieldValue,
  setFieldTouched,
  style,
}) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  return (
    <>
      <MainModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      >
        <PaymentArea
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          style={style}
          afterSubmit={() => {
            setIsModalVisible(false);
          }}
        />
      </MainModal>
      <Button
        onPress={() => {
          setIsModalVisible(true);
        }}
        title={
          value != null && Object.keys(value).length > 0
            ? t('paymentConfirmed')
            : t('paymentMethod')
        }
        disabled={value != null && Object.keys(value).length > 0}
        disabledStyle={{
          backgroundColor: theme.colors.success,
        }}
      />
    </>
  );
};

export default FormField(PaymentForm);
